import { connect } from 'react-redux'
import { compose } from 'recompose'
import { withRouter } from 'react-router-dom'

import withTranslation from '../../../globals/components/withTranslation'
import { withSnackbar } from 'notistack';
import Component from './component'

export default compose(withTranslation, withRouter, connect())(withSnackbar(Component))
